import { CountryFlag } from '@pmi.web/react-country-flags';
import { UserAvatar } from 'components/icons';
import { useGlobalConfigsContext } from 'contexts';
import { PII } from 'features/pii';
import { useTranslation } from 'libs/translations';
import { IUserProfile } from 'types';

import { useUserHeader } from './useUserHeader';

interface IUserHeaderMinimisedProps {
  readonly user: IUserProfile;
}

export function UserHeaderMinimised(props: IUserHeaderMinimisedProps) {
  const { t } = useTranslation();
  const {
    device: { supportsHover }
  } = useGlobalConfigsContext();

  const {
    name,
    userId,
    isDiscountCustomer,
    isTeampartner,
    isProspect,
    hasSponsorActivity,
    country
  } = useUserHeader(props.user);

  return (
    <div
      className={`flex flex-row w-full px-2 ${
        supportsHover
          ? 'hover:bg-secondary hover:rounded hover:text-active'
          : ''
      }`}
    >
      <div
        className={`mt-[5px] w-fit h-fit rounded-full relative ${
          hasSponsorActivity ? 'ring-2 ring-success' : ''
        }`}
      >
        <UserAvatar
          userName={name}
          size="small"
          userType={
            isDiscountCustomer
              ? 'discount-customer'
              : isTeampartner
              ? 'teampartner'
              : isProspect
              ? 'prospect'
              : 'customer'
          }
        />
      </div>

      <div className="ml-xs text-sm text-left w-full truncate shrink">
        <PII value={name} type="name" />

        <div className="flex flex-row flex-wrap gap-xs items-center">
          <p className="text-silver pmi-caption">
            {userId ? (
              <>
                #<PII value={userId} type="tpid" />
              </>
            ) : (
              t('Pending user registration')
            )}
          </p>

          {country && (
            <CountryFlag
              style={{ maxWidth: 16, maxHeight: 16 }}
              countryCode={country}
            />
          )}
        </div>
      </div>
    </div>
  );
}
